import axios from 'axios';
import Cookies from 'js-cookie';
import { v4 } from 'uuid';

const client = axios.create();

const randomValue = v4();

Cookies.set('csrf_token', randomValue);

export default client;
